/**
 * Decodes a JWT token and returns the payload
 * @param token - The JWT token to decode
 * @returns The decoded payload or null if invalid
 */
export function decodeJWT(token: string): any {
  try {
    // JWT has three parts separated by dots: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    
    // Add padding if needed for base64 decoding
    const paddedPayload = payload + '==='.slice((payload.length + 3) % 4);
    
    // Decode from base64
    const decodedPayload = atob(paddedPayload);
    
    // Parse as JSON
    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
}

/**
 * Extracts cognito groups from a JWT token
 * @param token - The JWT access token
 * @returns Array of cognito groups or empty array if none found
 */
export function getCognitoGroups(token: string): string[] {
  const payload = decodeJWT(token);
  
  if (!payload) {
    return [];
  }

  // Extract cognito:groups claim
  const cognitoGroups = payload['cognito:groups'];
  
  if (Array.isArray(cognitoGroups)) {
    return cognitoGroups;
  }
  
  return [];
}